module.exports = __webpack_public_path__ + "static/media/Aider-healthcare-logo.57e2bb8d.webp";